import { GetHeroBannerModel } from './B01HeroBanner.service';
import { B01HeroBannerProps } from './B01HeroBanner.type';
import { HeroBanner } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { PromptForUnavailableInTheme } from 'src/shared/PromptForUnavailableInTheme';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';

export const Default = (props?: B01HeroBannerProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (context?.siteTheme?.value === 'Corporate')
    return (
      <PromptForUnavailableInTheme
        siteTheme={context?.siteTheme?.value}
        componentName={props?.rendering?.componentName}
      />
    );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <HeroBanner
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...GetHeroBannerModel(props)}
    />
  );
};
